// extracted by mini-css-extract-plugin
export default {"separator":"baroqueSeparator_separator__D9DLS"};